import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OrderQuery } from '@modules/order/state/order-query';
import { ProcedureConfigurationService } from '@modules/order/services/procedure-configuration.service';
import { ShellQuery } from '@shared/store/shell/shell-query';
import { IdName } from '@shared/models/id-name';
import { Maybe } from '@/types/globals';
import { ProcedureTypeService } from './procedure-type.service';

@Injectable()
export class RxProcedureTypeControlFacade {
	procedureType$: Observable<Maybe<IdName>> = this.orderQuery.type$;
	procedureTypes$ = this.procedureConfigurationService.types$;
	isProcedureAndTypeReadOnly$ = this.shellQuery.isReadOnly$;

	constructor(
		private readonly orderQuery: OrderQuery,
		private readonly procedureConfigurationService: ProcedureConfigurationService,
		private readonly shellQuery: ShellQuery,
		private readonly procedureTypeService: ProcedureTypeService
	) {}

	handleProcedureTypeChanged(procedureTypeId: number): Observable<boolean> {
		return this.procedureTypeService.handleProcedureTypeChanged(procedureTypeId);
	}
}
